// todo move this file to module
export let RescueOption = {
    '1': 'فعال',
    '0': 'غیرفعال',
}